<template>
  <v-select
    :disabled="activateOrDeactivate"
    @change="updateValue($event)"
    class="select"
    :label="label"
    :items="selectOptions"
    :value="value"
    dense
    solo
  >
    <template slot="label">
      <span class="itemText">{{ label }}</span>
    </template>

    <template slot="selection" slot-scope="data">
      <span class="itemText">{{ data.item }}</span>
    </template>

    <template slot="item" slot-scope="data">
      <span class="itemText">{{ data.item }}</span>
    </template>
  </v-select>
</template>

<script>
export default {
  methods: {
    updateValue: function(value) {
      this.$emit("input", value);
    }
  },
  computed: {
    activateOrDeactivate() {
      if (this.option === "country") return false;
      if (this.option === "state" && this.filterValues.country !== null)
        return false;
      if (this.option === "city" && this.filterValues.state !== null)
        return false;
      if (this.option === "company" && this.filterValues.city !== null)
        return false;
      return true;
    }
  },
  props: {
    label: {
      type: String,
      required: true
    },
    option: {
      type: String,
      required: true
    },
    selectOptions: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    filterValues: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
.select {
  width: 240px;
}

.itemText {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #424242;
}
</style>
